import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    root: {},

    title: {
        fontSize: '20px',
    }
    
}));


export default function Header(props) {
    const { className, ...rest } = props;
    const classes = useStyles();
    return (
        <div {...rest} className={clsx(classes.root, className)} >
            <Grid alignItems="flex-end" container justify="space-between" spacing={3} >
                <Grid item>
                    
                   
                </Grid>
                <Grid item>
                  
                </Grid>
            </Grid>
            <div style={{marginBottom: "20px"}}></div>
        </div>
        
    )
}
